export const ResizeHandle = ({ onMouseDown }: { onMouseDown: (e: React.MouseEvent) => void }) => {
  return (
    <div
      onMouseDown={onMouseDown}
      onClick={(e) => e.stopPropagation()} // Evita ordenar ao clicar no resize
      className="group absolute bottom-0 right-0 top-0 z-20 flex w-1 cursor-col-resize touch-none select-none justify-center hover:bg-primary/50"
    >
      {/* Linha visual que aparece no hover */}
      <div className="h-full w-[1px] bg-border group-hover:bg-primary" />
    </div>
  );
};
